import {
  OPTANON_CONSENT_COOKIE,
  hasAnalyticsConsentFromOptanonValue,
} from '@/utils/server/consent/getAnalyticsConsentFromOptanonCookie';

const readSavedConsentCookie = () => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const prefix = `${OPTANON_CONSENT_COOKIE}=`;
  return document.cookie
    .split('; ')
    .find(cookie => cookie.startsWith(prefix))
    ?.slice(prefix.length);
};

const getClientShouldUseCookielessMode = () => {
  if (
    typeof navigator !== 'undefined' &&
    navigator.globalPrivacyControl === true
  ) {
    return true;
  }

  if (typeof window !== 'undefined' && window.OnetrustActiveGroups) {
    return window.OnetrustActiveGroups.split(',').length <= 4;
  }

  // Until OneTrust loads, a choice from an earlier visit is only in its cookie
  return (
    hasAnalyticsConsentFromOptanonValue(readSavedConsentCookie()) === false
  );
};

export default getClientShouldUseCookielessMode;
